<form
  [formGroup]="datasetForm"
  novalidate
  (submit)="onSubmit()"
  [ngClass]="{ 'in-page': !isAction }"
  [nbSpinner]="isLoading"
  nbSpinnerSize="small"
  nbSpinnerStatus="info"
>
  <nb-card [ngClass]="{ 'card-action': isAction }">
    <nb-card-header>
      <div class="d-flex justify-content-between">
        <div style="display: flex; gap: 1rem; align-items: center">
          {{ title }}
        </div>
        <button
          (click)="dismiss()"
          type="button"
          class="btn-close"
          aria-label="Close"
        ></button>
      </div>
    </nb-card-header>
    <nb-card-body>
      <nb-stepper
        #stepper
        [linear]="false"
        [ngClass]="{ 'hidden-step': isUpdate }"
      >
        <nb-step label="Knowledge">
          <div class="dataset-wrap">
            <div class="row card-action-body">
              <div class="pe-4 col-md-12" *ngIf="!isUpdate">
                <div class="col-md-12 mb-2">
                  <label for="input-name" class="form-label label required"
                    >Name</label
                  >
                  <input
                    autofocus
                    #inputName
                    type="text"
                    formControlName="name"
                    nbInput
                    [(ngModel)]="data.name"
                    fullWidth
                    [status]="
                      datasetForm.controls['name'].invalid &&
                      (datasetForm.controls['name'].dirty ||
                        datasetForm.controls['name'].touched)
                        ? 'danger'
                        : 'basic'
                    "
                    id="input-name"
                    placeholder="Name"
                    fieldSize="small"
                  />
                  <ng-container
                    *ngIf="
                      datasetForm.controls['name'].invalid &&
                      (datasetForm.controls['name'].dirty ||
                        datasetForm.controls['name'].touched)
                    "
                  >
                    <p
                      class="caption status-danger"
                      style="margin-bottom: 0"
                      *ngIf="
                        datasetForm.controls['name'].hasError('required') ||
                        datasetForm.controls['name'].hasError('whitespace')
                      "
                    >
                      Name is required
                    </p>
                    <p
                      class="caption status-danger"
                      style="margin-bottom: 0"
                      *ngIf="datasetForm.controls['name'].errors.isExist"
                    >
                      Name already exist.
                    </p>
                    <p
                      class="caption status-danger"
                      style="margin-bottom: 0"
                      *ngIf="
                        datasetForm.controls['name'].errors.maxlength &&
                        !datasetForm.controls['name'].hasError('required') &&
                        !datasetForm.controls['name'].hasError('whitespace')
                      "
                    >
                      Maximum length is 50 characters.
                    </p>
                    <p
                      class="caption status-danger"
                      style="margin-bottom: 0"
                      *ngIf="
                        datasetForm.controls['name'].errors.regex &&
                        !datasetForm.controls['name'].errors.maxlength &&
                        !datasetForm.controls['name'].hasError('required') &&
                        !datasetForm.controls['name'].hasError('whitespace')
                      "
                    >
                      Name cannot contain any of the following characters: \ / :
                      *? " < > |
                    </p>
                    <p
                      class="caption status-danger"
                      *ngIf="datasetForm.controls['name'].errors.serverError"
                    >
                      {{ datasetForm.controls["name"].errors.serverError }}
                    </p>
                  </ng-container>
                </div>
                <div class="col-md-12 mb-2">
                  <label for="description" class="form-label label"
                    >Description</label
                  >
                  <textarea
                    id="description"
                    type="text"
                    nbInput
                    placeholder="Description"
                    formControlName="description"
                    style="height: 90px; resize: none"
                    [(ngModel)]="data.description"
                    fullWidth
                    fieldSize="small"
                  >
                  </textarea>
                </div>
                <!-- <div class="col-md-12 mb-2">
                  <label for="type" class="form-label label">Format</label>
                  <div class="flex-type">
                    <div
                      (click)="changeType('TEXT')"
                      class="type-item enable-type"
                      [ngClass]="{ 'type-item-active': data.type == 'TEXT' }"
                    >
                      <button
                        nbButton
                        size="small"
                        ghost
                        status="info"
                        style="padding: 0"
                      >
                        <nb-icon icon="text-outline"></nb-icon>
                      </button>
                      <span>Text Format</span>
                    </div>
                    <div
                      class="type-item disable-type"
                      matTooltip="Incoming soon..."
                      [matTooltipPosition]="'above'"
                    >
                      <button
                        nbButton
                        size="small"
                        ghost
                        status="success"
                        style="padding: 0"
                      >
                        <nb-icon icon="list-outline"></nb-icon>
                      </button>
                      <span>Table Format</span>
                    </div>
                    <div
                      class="type-item disable-type"
                      matTooltip="Incoming soon..."
                      [matTooltipPosition]="'above'"
                    >
                      <button
                        nbButton
                        size="small"
                        ghost
                        status="warning"
                        style="padding: 0"
                      >
                        <nb-icon icon="image-2"></nb-icon>
                      </button>
                      <span>Image Format</span>
                    </div>
                  </div>
                </div> -->
                <div class="col-md-12 mb-2">
                  <div class="form-label d-flex" style="align-items: center">
                    <label for="data-source" class="label"> Data Source </label>
                    <nb-icon
                      class="ms-1"
                      style="color: #929bb3; width: 15px"
                      nbTooltip="Select the data source on which you want to train knowledge."
                      nbTooltipPlacement="end"
                      nbTooltipStatus="basic"
                      nbTooltipTrigger="hover"
                      icon="question-mark-circle-outline"
                    >
                    </nb-icon>
                  </div>
                  <div class="data-source-wrapper">
                    <div
                      (click)="changeSourceType('WEB_CRAWL')"
                      class="type-item enable-type"
                      [ngClass]="{
                        'type-item-active': data.sourceType == 'WEB_CRAWL'
                      }"
                    >
                      <button
                        nbButton
                        size="small"
                        ghost
                        style="padding: 0"
                        type="button"
                      >
                        <nb-icon icon="globe-2"></nb-icon>
                      </button>
                      <div class="d-flex flex-column">
                        <span>Website</span>
                        <span class="data-source-des"
                          >Add website information to your knowledge base and
                          make it available to your bot.</span
                        >
                      </div>
                    </div>
                    <div
                      (click)="changeSourceType('LOCAL_DOCUMENT')"
                      class="type-item enable-type"
                      [ngClass]="{
                        'type-item-active': data.sourceType == 'LOCAL_DOCUMENT'
                      }"
                    >
                      <button
                        nbButton
                        size="small"
                        ghost
                        style="padding: 0"
                        type="button"
                      >
                        <nb-icon icon="file-text"></nb-icon>
                      </button>
                      <div class="d-flex flex-column">
                        <span>Document</span>
                        <span class="data-source-des"
                          >Upload PDF, TXT, DOCX, MD to your knowledge
                          base.</span
                        >
                      </div>
                    </div>
                    <div
                      (click)="changeSourceType('CUSTOM')"
                      class="type-item enable-type"
                      [ngClass]="{
                        'type-item-active': data.sourceType == 'CUSTOM'
                      }"
                    >
                      <button
                        nbButton
                        size="small"
                        ghost
                        style="padding: 0"
                        type="button"
                      >
                        <nb-icon icon="edit-2"></nb-icon>
                      </button>
                      <div class="d-flex flex-column">
                        <span>Custom</span>
                        <span class="data-source-des"
                          >Directly input knowledge into a simple text
                          editor.</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-md-12"
                style="margin-top: 0.25rem"
                *ngIf="data.sourceType == 'WEB_CRAWL'"
              >
                <div class="col-md-12 mb-3">
                  <div
                    class="url-group"
                    style="
                      display: flex;
                      justify-content: center;
                      align-items: flex-end;
                    "
                  >
                    <div style="flex: 1 1 80%">
                      <label for="input-url" class="form-label label"
                        >Crawl URL
                      </label>
                      <input
                        formControlName="mainURL"
                        nbInput
                        fieldSize="small"
                        [(ngModel)]="mainURL"
                        fullWidth
                        id="input-url"
                        placeholder="https://example.com"
                        (keyup.enter)="extractURL()"
                      />
                    </div>
                    <div>
                      <label for="input-crawl-depth" class="form-label label"
                        >Crawl Depth
                        <nb-icon
                          class="ms-1"
                          style="color: #929bb3; width: 15px"
                          nbTooltip="The maximum depth that will be allowed to crawl any site. The depth should be from 1 to 3. The higher depth value is, the longer it takes to finish crawling."
                          nbTooltipPlacement="right"
                          nbTooltipStatus="basic"
                          nbTooltipTrigger="hover"
                          icon="question-mark-circle-outline"
                        >
                        </nb-icon>
                      </label>
                      <input
                        formControlName="crawlDepth"
                        nbInput
                        fieldSize="small"
                        fullWidth
                        [(ngModel)]="crawlDepth"
                        min="1"
                        max="4"
                        id="input-crawl-depth"
                        placeholder="1"
                      />
                    </div>
                    <div
                      nbTooltip="Searching child URLs... please wait..."
                      nbTooltipPlacement="bottom"
                      nbTooltipStatus="control"
                      [nbTooltipDisabled]="!isLoadingExtract"
                    >
                      <button
                        nbButton
                        status="primary"
                        size="small"
                        type="button"
                        (click)="extractURL()"
                        [disabled]="!mainURL || isLoadingExtract"
                      >
                        <nb-icon
                          [icon]="
                            !isLoadingExtract
                              ? 'search-outline'
                              : 'refresh-outline'
                          "
                          [ngClass]="{ 'loading-icon': isLoadingExtract }"
                        ></nb-icon>
                      </button>
                    </div>
                  </div>
                </div>
                <div *ngIf="isRetrieve" class="retrieve-processing">
                  <div class="p-4 text-center" style="font-size: 14px">
                    <div>
                      Please wait while we retrieve the pages. This may take
                      some time.
                    </div>
                    <div>Please don't close or refresh the page.</div>
                  </div>
                </div>
              </div>
              <div
                class="mb-3 col-md-12"
                *ngIf="data.sourceType == 'WEB_CRAWL'"
              >
                <div
                  #urlBox
                  class="col-md-12 mb-3 urls-wrapper url-area-action url-list p-4"
                  *ngIf="!isRetrieve"
                >
                  <div
                    style="
                      width: 100%;
                      padding-bottom: 1rem;
                      margin-bottom: 1rem;
                      border-bottom: 2px solid #ccc;
                    "
                  >
                    <label for="new-input-url" class="form-label label"
                      >Add URL
                      <nb-icon
                        class="ms-1"
                        style="color: #929bb3; width: 15px"
                        nbTooltip="Add new URL manually."
                        nbTooltipPlacement="right"
                        nbTooltipStatus="basic"
                        nbTooltipTrigger="hint"
                        icon="question-mark-circle-outline"
                      >
                      </nb-icon>
                    </label>
                    <div style="display: flex; gap: 0.5rem">
                      <input
                        formControlName="newURL"
                        nbInput
                        fieldSize="small"
                        [(ngModel)]="newURL"
                        fullWidth
                        id="new-input-url"
                        placeholder="https://example.com"
                        (keyup.enter)="handleAddNewURL()"
                      />
                      <button
                        nbButton
                        status="primary"
                        size="small"
                        type="button"
                        (click)="handleAddNewURL()"
                        [disabled]="!newURL"
                      >
                        <nb-icon icon="plus"></nb-icon>
                      </button>
                    </div>
                  </div>
                  <div *ngIf="listUrl.length <= 0">
                    <span style="font-size: 13px">No data to display. </span>
                  </div>
                  <div class="check-wrapper-all" *ngIf="listUrl.length > 0">
                    <nb-checkbox
                      (checkedChange)="toggleAll($event)"
                      [checked]="checkAll"
                      >All URLs</nb-checkbox
                    >
                    <button
                      nbButton
                      size="tiny"
                      type="button"
                      (click)="removeAll()"
                      *ngIf="!checkAll"
                    >
                      <nb-icon
                        icon="minus-circle-outline"
                        status="basic"
                      ></nb-icon>
                    </button>
                  </div>
                  <div
                    *ngFor="let url of listUrl; let i = index"
                    class="check-wrapper"
                  >
                    <nb-checkbox
                      (checkedChange)="toggle($event, i)"
                      [checked]="url.enable"
                      >{{ url?.tokens ? url.tokens + " tokens - " : "" }}
                      {{ url.url }}</nb-checkbox
                    >
                    <button
                      nbButton
                      size="tiny"
                      type="button"
                      (click)="removeUrl(i)"
                      ghost
                      title="Delete URL"
                    >
                      <nb-icon
                        icon="minus-circle-outline"
                        status="basic"
                      ></nb-icon>
                    </button>
                  </div>
                </div>
                <div class="total-count" *ngIf="data.type == 'URL'">
                  <span>{{ listUrl.length }} total</span>
                </div>
              </div>
              <div class="col-md-12" *ngIf="data.sourceType == 'CUSTOM'">
                <div class="col-md-12">
                  <label
                    for="name-training-knowledge"
                    class="form-label label required"
                    >Document Name</label
                  >
                  <input
                    type="text"
                    formControlName="documentName"
                    nbInput
                    [(ngModel)]="data.documentName"
                    fullWidth
                    [status]="
                      datasetForm.controls['documentName'].invalid &&
                      (datasetForm.controls['documentName'].dirty ||
                        datasetForm.controls['documentName'].touched)
                        ? 'danger'
                        : 'basic'
                    "
                    id="name-training-knowledge"
                    placeholder="Document Name"
                    fieldSize="small"
                  />
                  <ng-container
                    *ngIf="
                      datasetForm.controls['documentName'].invalid &&
                      (datasetForm.controls['documentName'].dirty ||
                        datasetForm.controls['documentName'].touched)
                    "
                  >
                    <p
                      class="caption status-danger"
                      style="margin-bottom: 0"
                      *ngIf="
                        datasetForm.controls['documentName'].hasError(
                          'required'
                        ) ||
                        datasetForm.controls['documentName'].hasError(
                          'whitespace'
                        )
                      "
                    >
                      Document Name is required
                    </p>
                    <p
                      class="caption status-danger"
                      style="margin-bottom: 0"
                      *ngIf="
                        datasetForm.controls['documentName'].errors.maxlength &&
                        !datasetForm.controls['documentName'].hasError(
                          'required'
                        ) &&
                        !datasetForm.controls['documentName'].hasError(
                          'whitespace'
                        )
                      "
                    >
                      Maximum length is 50 characters.
                    </p>
                    <p
                      class="caption status-danger"
                      style="margin-bottom: 0"
                      *ngIf="
                        datasetForm.controls['documentName'].errors.regex &&
                        !datasetForm.controls['documentName'].errors
                          .maxlength &&
                        !datasetForm.controls['documentName'].hasError(
                          'required'
                        ) &&
                        !datasetForm.controls['documentName'].hasError(
                          'whitespace'
                        )
                      "
                    >
                      Document Name cannot contain any of the following
                      characters: \ / : *? " < > |
                    </p>
                    <p
                      class="caption status-danger"
                      *ngIf="datasetForm.controls['name'].errors.serverError"
                    >
                      {{ datasetForm.controls["name"].errors.serverError }}
                    </p>
                  </ng-container>
                </div>
                <div class="col-md-12">
                  <label
                    for="content-training-knowledge"
                    class="form-label label required"
                    >Content</label
                  >
                  <textarea
                    id="content-training-knowledge"
                    type="text"
                    nbInput
                    placeholder="Content"
                    formControlName="content"
                    style="min-height: 200px"
                    [(ngModel)]="data.content"
                    fullWidth
                    fieldSize="small"
                    (ngModelChange)="onChangeContentText($event)"
                  >
                  </textarea>
                </div>
              </div>
              <div
                class="document col-md-12"
                *ngIf="data.sourceType == 'LOCAL_DOCUMENT'"
                style="overflow-y: scroll; padding-right: 1.5rem"
              >
                <div class="col-md-12">
                  <label for="name" class="form-label label required"
                    >Documents</label
                  >
                  <div>
                    <uppy-dashboard
                      class="is-action"
                      [ngClass]="{ 'is-action-margin': isAction }"
                      [uppy]="uppy"
                    >
                    </uppy-dashboard>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nb-step>

        <nb-step label="Segmentation" *ngIf="!isUpdate">
          <div class="dataset-wrap">
            <div class="row card-action-body">
              <div class="pe-4 col-md-12">
                <div class="col-md-12 mb-2">
                  <label for="input-model" class="form-label label"
                    >Embedding Model</label
                  >
                  <nb-select
                    id="input-model"
                    placeholder="Select Embedding Model"
                    formControlName="model"
                    [(ngModel)]="data.model"
                    size="small"
                    fullWidth
                  >
                    <nb-option-group title="OpenAI">
                      <nb-option
                        value="text-embedding-ada-002"
                        class="option-model"
                      >
                        <span>text-embedding-ada-002</span>
                        <nb-icon
                          class="ms-1"
                          style="color: #929bb3; width: 15px"
                          nbTooltip="A powerful OpenAI model for creating text embeddings, useful for tasks like search and classification."
                          nbTooltipPlacement="left"
                          nbTooltipStatus="basic"
                          nbTooltipTrigger="hint"
                          icon="question-mark-circle-outline"
                        >
                        </nb-icon
                      ></nb-option>
                      <nb-option
                        value="text-embedding-3-small"
                        class="option-model"
                      >
                        <span>text-embedding-3-small</span>
                        <nb-icon
                          class="ms-1"
                          style="color: #929bb3; width: 15px"
                          nbTooltip="A lightweight model for generating faster, less detailed text embeddings."
                          nbTooltipPlacement="left"
                          nbTooltipStatus="basic"
                          nbTooltipTrigger="hint"
                          icon="question-mark-circle-outline"
                        >
                        </nb-icon
                      ></nb-option>
                      <nb-option
                        value="text-embedding-3-large"
                        class="option-model"
                        ><span>text-embedding-3-large</span>
                        <nb-icon
                          class="ms-1"
                          style="color: #929bb3; width: 15px"
                          nbTooltip="A more advanced version for detailed, high-quality text embeddings."
                          nbTooltipPlacement="left"
                          nbTooltipStatus="basic"
                          nbTooltipTrigger="hint"
                          icon="question-mark-circle-outline"
                        >
                        </nb-icon
                      ></nb-option>
                    </nb-option-group>

                    <nb-option-group title="Ollama">
                      <nb-option value="mxbai-embed-large" class="option-model">
                        <span>mxbai-embed-large</span>
                        <nb-icon
                          class="ms-1"
                          style="color: #929bb3; width: 15px"
                          nbTooltip="A large embedding model by Ollama for producing high-quality vector representations of text."
                          nbTooltipPlacement="left"
                          nbTooltipStatus="basic"
                          nbTooltipTrigger="hint"
                          icon="question-mark-circle-outline"
                        >
                        </nb-icon>
                      </nb-option>
                    </nb-option-group>
                  </nb-select>
                </div>
                <div class="col-md-12 mb-2">
                  <label for="input-chunk" class="form-label label"
                    >Settings</label
                  >
                  <div class="d-flex flex-column" style="gap: 0.5rem">
                    <div
                      (click)="changeTrunk('auto')"
                      class="type-item enable-type enable-type-chunk"
                      [ngClass]="{
                        'type-item-chunk-active': data.chunkType == 'auto'
                      }"
                    >
                      <button
                        nbButton
                        size="small"
                        status="success"
                        ghost
                        type="button"
                        style="padding: 0"
                      >
                        <nb-icon icon="flash"></nb-icon>
                      </button>
                      <div class="d-flex flex-column">
                        <span>Automatic</span>
                        <span class="data-source-des"
                          >Auto-apply chunking and preprocessing rules.
                          Recommended for unfamiliar users.</span
                        >
                      </div>
                      <nb-icon
                        style="position: absolute; right: 45px"
                        *ngIf="data.chunkType == 'auto'"
                        icon="radio-button-on"
                        status="primary"
                      ></nb-icon>
                    </div>
                    <div
                      (click)="changeTrunk('custom')"
                      class="type-item enable-type enable-type-chunk type-item-custom"
                      [ngClass]="{
                        'type-item-chunk-active': data.chunkType == 'custom'
                      }"
                    >
                      <div class="type-item-custom-wrapper">
                        <button
                          nbButton
                          size="small"
                          status="info"
                          ghost
                          type="button"
                          style="padding: 0"
                        >
                          <nb-icon icon="options-2"></nb-icon>
                        </button>
                        <div class="d-flex flex-column">
                          <span>Custom</span>
                          <span class="data-source-des"
                            >Customize segment rules, segment length, and
                            preprocessing rules, etc.</span
                          >
                        </div>
                        <nb-icon
                          style="position: absolute; right: 45px"
                          *ngIf="data.chunkType == 'custom'"
                          icon="radio-button-on"
                          status="primary"
                        ></nb-icon>
                      </div>
                      <div
                        *ngIf="data.chunkType == 'custom'"
                        style="width: 100%"
                      >
                        <div class="row">
                          <div class="col-md-12 mb-2">
                            <label
                              for="input-delimiter"
                              class="form-label label"
                              >Delimiter</label
                            >
                            <input
                              type="text"
                              formControlName="paragraph_separator"
                              nbInput
                              [(ngModel)]="data.paragraph_separator"
                              fullWidth
                              id="input-delimiter"
                              placeholder="Delimiter"
                              fieldSize="small"
                            />
                          </div>
                          <div class="col-md-12 mb-2">
                            <div
                              class="form-label d-flex"
                              style="align-items: center"
                            >
                              <label for="input-chunk-lenght" class="label">
                                Maximum Length
                              </label>
                              <nb-icon
                                class="ms-1"
                                style="color: #929bb3; width: 15px"
                                nbTooltip="The maximum length should be 100-5000."
                                nbTooltipPlacement="end"
                                nbTooltipStatus="basic"
                                nbTooltipTrigger="hover"
                                icon="question-mark-circle-outline"
                              >
                              </nb-icon>
                            </div>
                            <input
                              type="number"
                              formControlName="chunk_size"
                              nbInput
                              [(ngModel)]="data.chunk_size"
                              fullWidth
                              id="input-chunk-lenght"
                              placeholder="Maximum Chunk Length"
                              fieldSize="small"
                              (keypress)="onkeypress($event)"
                            />
                          </div>
                          <div class="col-md-12 mb-2">
                            <div
                              class="form-label d-flex"
                              style="align-items: center"
                            >
                              <label for="input-chunk-overlap" class="label">
                                Overlap
                              </label>
                              <nb-icon
                                class="ms-1"
                                style="color: #929bb3; width: 15px"
                                nbTooltip="Setting overlap helps maintain semantic relevance, improving retrieval. A 10%-25% overlap of the max size is recommended."
                                nbTooltipPlacement="end"
                                nbTooltipStatus="basic"
                                nbTooltipTrigger="hover"
                                icon="question-mark-circle-outline"
                              >
                              </nb-icon>
                            </div>
                            <input
                              min="0"
                              type="number"
                              formControlName="chunk_overlap"
                              nbInput
                              [(ngModel)]="data.chunk_overlap"
                              fullWidth
                              id="input-chunk-overlap"
                              placeholder="Chunk Overlap"
                              fieldSize="small"
                              (keypress)="onkeypress($event)"
                            />
                          </div>
                          <div class="col-md-12 mb-2">
                            <label
                              style="display: block"
                              for="input-chunk-preprocessing"
                              class="form-label label"
                              >Text Preprocessing Rules
                            </label>
                            <nb-checkbox
                              formControlName="remove_extra_spaces"
                              [(ngModel)]="data.remove_extra_spaces"
                            >
                              Replace consecutive spaces, newlines and
                              tabs</nb-checkbox
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nb-step>
      </nb-stepper>
    </nb-card-body>
    <nb-card-footer>
      <div class="d-flex justify-content-end">
        <button
          type="submit"
          [disabled]="
            !datasetForm.valid ||
            isLoading ||
            isSaveLoading ||
            !data.sourceType ||
            (data.sourceType == 'WEB_CRAWL' && listUrl.length <= 0) ||
            (data.sourceType == 'LOCAL_DOCUMENT' && totalFile <= 0) ||
            (data.sourceType == 'CUSTOM' && !data.content?.trim())
          "
          status="primary"
          class="ms-2"
          size="small"
          nbButton
        >
          <nb-icon icon="save-outline"></nb-icon>Save & Train
        </button>
      </div>
    </nb-card-footer>
  </nb-card>
</form>
